/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PushSubscriptionKey
 */
export interface PushSubscriptionKey {
    /**
     * An Elliptic curve Diffie–Hellman public key on the P-256 curve (that is, the NIST secp256r1 elliptic curve). The resulting key is an uncompressed point in ANSI X9.62 format.
     * @type {string}
     * @memberof PushSubscriptionKey
     */
    p256dh: string;
    /**
     * An authentication secret, as described in Message Encryption for Web Push.
     * @type {string}
     * @memberof PushSubscriptionKey
     */
    auth: string;
}

export function PushSubscriptionKeyFromJSON(json: any): PushSubscriptionKey {
    return PushSubscriptionKeyFromJSONTyped(json, false);
}

export function PushSubscriptionKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PushSubscriptionKey {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'p256dh': json['p256dh'],
        'auth': json['auth'],
    };
}

export function PushSubscriptionKeyToJSON(value?: PushSubscriptionKey | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'p256dh': value.p256dh,
        'auth': value.auth,
    };
}

